// 运行时配置
import { history, matchRoutes, setLocale } from '@umijs/max';
import { autoFixContext } from 'react-activation';
import jsxRuntime from 'react/jsx-runtime';
import jsxDevRuntime from 'react/jsx-dev-runtime';
import { getUserInfo, getCommonData } from './api/login';
import LayoutHeader from './components/LayoutHeader';
import { message } from 'antd';
import { redirectToLogin } from './utils/redirectToLogin';
import { getWatermarkConfig } from '@/layout/watermark';
import { systemMenuIcons } from '@/commonConfig/index';
import sensorLoader from './utils/sensorLoader';
import { getUuid } from '@/utils/common';
import { isGlobalEnv } from './config';
import cookie from 'js-cookie';
import intl from 'react-intl-universal';
import locales from './locales/index';

import { ConfigProvider } from 'antd';
import antdZhCN from 'antd/locale/zh_CN';

sensorLoader.startLoad();
autoFixContext(
    [jsxRuntime, 'jsx', 'jsxs', 'jsxDEV'],
    [jsxDevRuntime, 'jsx', 'jsxs', 'jsxDEV'],
);

export { request } from './requestConfig';

if (!cookie.get('lang')) {
    cookie.set('lang', 'zh-CN', {
        domain: '.popmart.com',
        Secure: true,
        SameSite: 'None',
        Partitioned: true,
    });
}

// const support = [
//     { name: 'English', value: 'en-US' },
//     { name: '简体中文', value: 'zh-CN' },
//     { name: '繁体中文', value: 'zh-TW' },
// ];

// 全局初始化数据配置，用于 Layout 用户信息和权限初始化
// 更多信息见文档：https://next.umijs.org/docs/api/runtime-config#getinitialstate
export async function getInitialState(): Promise<InitialStateType> {
    // 设置全局消息提示
    message.config({ maxCount: 2 });

    // 用户信息
    let userInfo: UserInfoType | undefined;
    // 常用数据
    let commonData: CommonDataType | undefined;
    // 接单状态
    let receiveStatus = 2;

    if (
        history.location.pathname !== '/login' &&
        history.location.pathname !== '/skip'
    ) {
        userInfo = await getUserInfo();
        commonData = await getCommonData();
        receiveStatus = userInfo?.autoReceiveStatus || 2;

        if (userInfo) {
            sensorLoader.login(userInfo.userId);
            sessionStorage.setItem('info', JSON.stringify(userInfo));
        }
    }
    if (!sessionStorage.getItem('uuid')) {
        sessionStorage.setItem('uuid', getUuid());
    }

    return {
        userInfo,
        commonData,
        loading: false,
        receiveStatus,
    };
}

const getMenuTitle = (name) => {
    if (name && (intl.get(name) || intl.get(`meun.${name}`))) {
        return intl.get(name) || intl.get(`meun.${name}`);
    }
    return name;
};
export const layout = ({ initialState }) => {
    return {
        layout: 'mix',
        logo: 'https://img.alicdn.com/tfs/TB1YHEpwUT1gK0jSZFhXXaAtVXa-28-27.svg',
        menu: {
            locale: false,
        },
        // pure: true,
        menuProps: {
            theme: 'dark',
            // onClick: ({ item, key, keyPath, domEvent }) => {
            //     console.log(item);
            // },
        },
        token: {
            sider: {
                colorBgLayout: 'rgba(22,35,85,0.1)',
                colorMenuBackground: '#162355',
                // 字体颜色
                colorTextMenu: 'rgba(255, 255, 255, 0.65)',

                // 菜单展开收起icon
                colorTextMenuSelected: 'rgba(255, 255, 255, 0.65)',
                colorTextMenuActive: '#fff',

                // 选中的菜单item背景色
                colorBgMenuItemSelected: '#2477FF',
                //收起侧边栏颜色
                colorBgCollapsedButton: '#162355',
                colorTextCollapsedButton: 'rgba(255, 255, 255, 0.65)',
                colorTextCollapsedButtonHover: '#fff',
            },
            header: {
                heightLayoutHeader: isGlobalEnv ? 42 : 84,
            },
        },
        enableDarkTheme: true,
        siderWidth: 180,
        headerRender: () => <LayoutHeader />,
        menuDataRender: (menuData: any[]) => {
            return (initialState?.userInfo?.menuData || menuData).map(
                (item: { path: string; [key: string]: any }) => {
                    return {
                        ...item,
                        icon: systemMenuIcons[item.path] || null,
                        name: getMenuTitle(item.name),
                        title: getMenuTitle(item.name),
                        children:
                            item.children?.map((chlid) => {
                                return {
                                    ...chlid,
                                    name: getMenuTitle(chlid.name),
                                    title: getMenuTitle(chlid.name),
                                };
                            }) || undefined,
                    };
                },
            );
        },
        menuItemRender: (itemProps, defaultDom) => {
            // console.log('menuItemRender====', itemProps, defaultDom);
            const onMenuItemClick = () => {
                // console.log('menuItemRender====', itemProps, defaultDom);
                history.push(itemProps.path);
                sensorLoader.reportClick('PopMartCustomerServiceCssMenu', {
                    menu_name: itemProps.name,
                    path: itemProps.path,
                });
            };
            return (
                <div
                    {...itemProps}
                    onClick={onMenuItemClick}
                >
                    {defaultDom}
                </div>
            );
        },

        // contentStyle: {
        //     background: '#f00',
        // },

        onPageChange: () => {
            // 如果没有登录，重定向到 login
            if (
                !initialState?.userInfo &&
                history.location.pathname !== '/login' &&
                history.location.pathname !== '/skip'
            ) {
                redirectToLogin();
            }
        },
        // 设置水印
        waterMarkProps: getWatermarkConfig(initialState),
    };
};

export async function onRouteChange({ location, clientRoutes }) {
    const route = matchRoutes(clientRoutes, location.pathname)?.pop()?.route;
    sensorLoader.reportClick('PopMartCustomerServiceCssPageView', {
        pageName: route.name,
        path: route.originPath,
    });

    // 如果当前连接不是天润嵌入页面的路由，隐藏iframe
    if (!route.originPath?.includes('/outer')) {
        console.log('[route change]隐藏天润iframe', route.originPath);
        // 隐藏iframe
        const iframe = document.querySelector('[data-iframe-hidden=false]');
        if (iframe) {
            iframe.setAttribute('data-iframe-hidden', 'true');
        }
    }

    if (route?.name) {
        setTimeout(() => {
            console.log('set title');
            document.title = getMenuTitle(route.name);
        }, 100);
    }
}

export function rootContainer(container) {
    console.log(cookie.get('lang'));
    setLocale(cookie.get('lang') || 'zh-CN');
    let currentLocale = intl.determineLocale({
        urlLocaleKey: 'lang',
        // 根据url的尾部标识来时别现在的语言环境
        cookieLocaleKey: 'lang',
    });
    intl.init({
        currentLocale,
        locales,
    });
    return <ConfigProvider locale={antdZhCN}>{container}</ConfigProvider>;
}
